module.exports = __webpack_public_path__ + "img/L_318_324.b1329199.png";